import React, { useState } from "react";


import {
  FaLeaf,
  FaChevronDown,
  FaChevronUp,
  FaCheck,
} from "react-icons/fa";

const styles = `
  * { box-sizing: border-box; }

  .ls-page-wrapper {
    background: #22c7b8;
    min-height: 100vh;
  }

  /* ── HERO ── */
  .ls-hero {
    background: #173b8f;
    width: 100%;
  }

  .ls-hero-inner {
    width: 92%;
    max-width: 1300px;
    margin: 0 auto;
    padding: 40px 0;
  }

  .ls-hero-heading-row {
    display: flex;
    align-items: center;
    gap: 14px;
    margin-bottom: 18px;
    flex-wrap: wrap;
  }

  .ls-hero-icon-box {
    width: 46px;
    height: 46px;
    min-width: 46px;
    background: #22c7b8;
    border-radius: 10px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
  }

  .ls-hero-title {
    color: #ffffff;
    font-size: 34px;
    font-weight: 700;
    margin: 0;
    font-family: "Exo", sans-serif;
    line-height: 1.2;
  }

  .ls-hero-desc {
    color: #f2f2f2;
    font-size: 15px;
    line-height: 1.9;
    max-width: 1000px;
    margin: 0;
  }

  /* ── ACCORDION SECTION ── */
  .ls-accordion-wrapper {
    width: 78%;
    max-width: 1050px;
    margin: 0 auto;
    padding: 28px 0 50px;
  }

  .ls-accordion-item {
    background: #ffffff;
    border-radius: 8px;
    margin-bottom: 10px;
    overflow: hidden;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
  }

  .ls-accordion-header {
    padding: 16px 20px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    cursor: pointer;
    transition: background 0.25s;
  }

  .ls-accordion-header.open  { background: #173b8f; }
  .ls-accordion-header.closed { background: #ffffff; }

  .ls-accordion-title {
    margin: 0;
    font-size: 16px;
    font-weight: 700;
    font-family: "Exo", sans-serif;
    line-height: 1.4;
    padding-right: 12px;
  }

  .ls-accordion-title.open  { color: #ffffff; }
  .ls-accordion-title.closed { color: #173b8f; }

  .ls-accordion-icon { flex-shrink: 0; }

  .ls-accordion-body {
    padding: 18px 24px 6px;
    background: #ffffff;
  }

  .ls-accordion-point {
    display: flex;
    align-items: center;
    gap: 12px;
    margin-bottom: 14px;
  }

  .ls-check-circle {
    width: 24px;
    height: 24px;
    min-width: 24px;
    border-radius: 50%;
    background: #22c7b8;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
  }

  .ls-point-text {
    margin: 0;
    color: #4b5563;
    font-size: 15px;
    line-height: 1.7;
    font-weight: 500;
  }

  /* ── TABLET: 768px – 1023px ── */
  @media (max-width: 1023px) {
    .ls-hero-title    { font-size: 28px; }
    .ls-accordion-wrapper { width: 88%; }
  }

  /* ── TABLET PORTRAIT: up to 900px ── */
  @media (max-width: 900px) {
    .ls-hero-title    { font-size: 26px; }
    .ls-hero-inner    { padding: 32px 0; }
    .ls-accordion-wrapper { width: 90%; padding: 24px 0 40px; }
  }

  /* ── MOBILE: up to 767px ── */
  @media (max-width: 767px) {
    .ls-hero-inner        { width: 94%; padding: 28px 0; }
    .ls-hero-heading-row  { gap: 12px; margin-bottom: 14px; }
    .ls-hero-icon-box     { width: 40px; height: 40px; min-width: 40px; border-radius: 8px; }
    .ls-hero-title        { font-size: 22px; }
    .ls-hero-desc         { font-size: 14px; line-height: 1.8; }
    .ls-accordion-wrapper { width: 94%; padding: 20px 0 36px; }
    .ls-accordion-header  { padding: 14px 16px; }
    .ls-accordion-title   { font-size: 15px; }
    .ls-accordion-body    { padding: 16px 16px 4px; }
    .ls-point-text        { font-size: 14px; }
  }

  /* ── SMALL MOBILE: up to 480px ── */
  @media (max-width: 480px) {
    .ls-hero-inner        { width: 96%; padding: 22px 0; }
    .ls-hero-title        { font-size: 19px; }
    .ls-hero-desc         { font-size: 13px; }
    .ls-accordion-wrapper { width: 96%; padding: 16px 0 28px; }
    .ls-accordion-header  { padding: 12px 14px; }
    .ls-accordion-title   { font-size: 14px; }
    .ls-check-circle      { width: 22px; height: 22px; min-width: 22px; }
    .ls-point-text        { font-size: 13px; }
    .ls-accordion-item    { margin-bottom: 8px; }
  }

  /* ── VERY SMALL: up to 360px ── */
  @media (max-width: 360px) {
    .ls-hero-title      { font-size: 17px; }
    .ls-accordion-title { font-size: 13px; }
  }
`;

function LifeSciencesPage() {
  const [openIndex, setOpenIndex] = useState(null);

  const toggle = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  const sections = [
    {
      title: "Drug Discovery & Development",
      points: [
        "Molecular Structure Prediction Agent",
        "Target Identification Agent",
        "Lead Compound Screening Agent",
        "Binding Affinity Prediction Agent",
        "Drug Repurposing Agent",
      ],
    },
    {
      title: "Genomics & Precision Medicine",
      points: [
        "Genome Sequencing Analysis Agent",
        "Variant Classification Agent",
        "Gene Expression Analysis Agent",
        "CRISPR Target Design Agent",
        "Personalized Treatment Agent",
      ],
    },
    {
      title: "Clinical Trials & Research",
      points: [
        "Trial Design Optimization Agent",
        "Patient Recruitment Agent",
        "Protocol Adherence Monitoring Agent",
        "Efficacy Trend Detection Agent",
        "Real-World Evidence Agent",
      ],
    },
    {
      title: "Diagnostics & Imaging",
      points: [
        "Radiology Interpretation Agent",
        "Digital Pathology Agent",
        "Clinical Lab Data Agent",
        "Early Disease Detection Agent",
        "Multi-Modal Diagnostic Agent",
      ],
    },
    {
      title: "Healthcare & Patient Engagement",
      points: [
        "Virtual Health Assistant Agent",
        "Symptom Checker Agent",
        "Mental Health Monitoring Agent",
        "Chronic Disease Management Agent",
        "Digital Therapeutics Agent",
      ],
    },
  ];

  return (
    <>
      <style>{styles}</style>

      <div className="ls-page-wrapper">

        {/* ── HERO ── */}
        <div className="ls-hero">
          <div className="ls-hero-inner">
            <div className="ls-hero-heading-row">
              <div className="ls-hero-icon-box">
                <FaLeaf style={{ color: "#ffffff", fontSize: "20px" }} />
              </div>
              <h1 className="ls-hero-title">The Life Sciences Sector</h1>
            </div>
            <p className="ls-hero-desc">
              This sector includes biotechnology, pharmaceuticals, and medical
              research. AI agents assist in drug discovery, clinical trial
              optimization, genomics, and predictive diagnostics—dramatically
              accelerating innovation in healthcare and patient treatment.
            </p>
          </div>
        </div>

        {/* ── ACCORDION ── */}
        <div className="ls-accordion-wrapper">
          {sections.map((section, index) => (
            <div key={index} className="ls-accordion-item">

              {/* HEADER */}
              <div
                className={`ls-accordion-header ${openIndex === index ? "open" : "closed"}`}
                onClick={() => toggle(index)}
              >
                <h2 className={`ls-accordion-title ${openIndex === index ? "open" : "closed"}`}>
                  {section.title}
                </h2>
                <span className="ls-accordion-icon">
                  {openIndex === index ? (
                    <FaChevronUp style={{ color: "#ffffff", fontSize: "15px" }} />
                  ) : (
                    <FaChevronDown style={{ color: "#173b8f", fontSize: "15px" }} />
                  )}
                </span>
              </div>

              {/* BODY */}
              {openIndex === index && (
                <div className="ls-accordion-body">
                  {section.points.map((point, i) => (
                    <div key={i} className="ls-accordion-point">
                      <div className="ls-check-circle">
                        <FaCheck style={{ color: "#ffffff", fontSize: "10px" }} />
                      </div>
                      <p className="ls-point-text">{point}</p>
                    </div>
                  ))}
                </div>
              )}

            </div>
          ))}
        </div>

      </div>
    </>
  );
}

export default LifeSciencesPage;
